import { Account } from './account';
import { BuddyRequest } from './buddy-request';
import { Horse } from './horse';
import { RegistrationCarryOver } from './registrationCarryOver';
import { RegistrationClothing } from './registrationClothing';
import { RegistrationExhibition } from './registrationExhibition';
import { RegistrationHotelRoom } from './registrationHotelRoom';
import { RegistrationPayment } from './registrationPayment';
import { RodeoEventRun } from './rodeoEventRun';
import { TurnoutReason } from './registration-change-request';

export class RodeoEventRegistration {
    id: number;
    rodeoEventId: number;
    
    created: string;
    payConfirmation: string;
    confirmationCode: string;
    status: string;
    placed: boolean;
    paid: boolean;
    lateFee: boolean;
    thirdPrefTurnout: boolean;

    buddyRequests: BuddyRequest[] = [];
    buddies: Account[] = [];
    buddyList: string;

    sidepotIds: number[] = [];
    carryOverIds: number[] = [];
    carryOvers: RegistrationCarryOver[] = [];
    exhibitions: RegistrationExhibition[] = [];
    hotelRooms: RegistrationHotelRoom[] = [];
    clothing: RegistrationClothing[] = [];
    scheduleIds: number[] = [];
    schedules: any[] = [];
    secondPrefTurnout: boolean;
    allPreferences: boolean;

    contestantOne: Account;
    contestantOneId: number;
    contestantTwo: Account;
    contestantTwoId: number;

    horseOne: Horse;
    horseOneName: string;
    horseOneId: number;
    horseTwo: Horse;
    horseTwoName: string;
    horseTwoId: number;

    payRider: boolean;

    isDraw: boolean;
    isTba: boolean;
    teammateHeader: boolean;
    updated: string;

    payments: RegistrationPayment[];
    purchaseOrderId: number;

    run: RodeoEventRun = new RodeoEventRun();
    runIdentifier: string;
    rvReservations?: EntryReservation[];
    stallReservations?: EntryReservation[];
    changeRequests?: any[];

    turnoutReason: TurnoutReason;

    constructor() {
        this.id = -1;
        this.run = new RodeoEventRun();
        this.buddyRequests = [];
        this.buddies = [];
        this.teammateHeader = false;
        this.payRider = true;
        this.thirdPrefTurnout = false;
    
        this.sidepotIds = [];
        this.scheduleIds = [];
        this.schedules = [];
        this.exhibitions = [];
    }
}

export interface EntryReservation {
    id: number;
    accountId: number;
    quantity: number;
    rodeoId: number;
    reservationStartDate?: string;
    reservationEndDate?: string;
  
    account?: Account
}


// WEBPACK FOOTER //
// ./src/model/rodeoEventRegistration.ts